/* eslint-disable */
import axios from "axios";

export default config => {
  const token = localStorage.getItem(config.api.tokenName);
  const headers = {
    "Accept": "application/json",
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return axios.create({
    baseURL: config.api.base,
    withCredentials: false,
    headers,
    xsrfHeaderName: "X-CSRFToken",
    xsrfCookieName: config.api.csrfToken,
  });
};
